import { Component, Prop, h } from '@stencil/core';

import EventBus from '../../services/service.eventBus';

@Component({
  tag: 'image-capture',
  styleUrl: 'image-capture.css',
  shadow: true,
})
export class ImageCapture {
  @Prop() imageGroupGuid = '';
  @Prop() imageUrls: string[] = [];
  @Prop() requiresAllPhotos = false;
  @Prop() shouldShowError = false;

  @Prop() theme: string;

  componentDidRender() {
    this.checkImageCaptureComponentIsValid();
  }

  componentDidLoad() {
    EventBus.publish('ComponentHasLoaded', 'image-capture');
  }

  checkImageCaptureComponentIsValid = () => {
    if (!this.requiresAllPhotos) {
      EventBus.publish('FormValidated', { form: 'image-capture-form', isValid: true });
      return;
    }

    const allPhotosUploaded = this.imageUrls.every((url) => !!url);

    if (!allPhotosUploaded) {
      EventBus.publish('FormValidated', { form: 'image-capture-form', isValid: false });
    } else {
      EventBus.publish('FormValidated', { form: 'image-capture-form', isValid: true });
    }
  };

  render() {
    return (
      <div class={`${this.theme}-theme`}>
        <image-capture-container
          imageGroupGuid={this.imageGroupGuid}
          imageUrls={this.imageUrls}
          requiresAllPhotos={this.requiresAllPhotos}
          shouldShowError={this.shouldShowError}
        />
      </div>
    );
  }
}
